export default __webpack_public_path__ + "locales/hy-AM/PeopleTranslations.json?hash=806f28cfaf85645e76db1696ecd408c0";